import { useEffect,useState } from 'react';
import { NavLink, Route, Routes, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from "react-icons/fa";
import './theme.css';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import MinistriesPage from './pages/MinistriesPage';
import SermonsPage from './pages/SermonsPage';
import NewsPage from './pages/NewsPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import ConstructionPage from './pages/Construction';
import Signin from './pages/SigninPage';
import logo from './assets/deliverance icon.jpg';


const navItems = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/ministries', label: 'Ministries' },
  { to: '/sermons', label: 'Sermons' },
  { to: '/news', label: 'News' },
  { to: '/contact', label: 'Contact' },
  {to:'/construction',label:'Construction'},


];

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return null;
}

function App() {

  const [menuOpen, setMenuOpen] = useState(false);

const location = useLocation();

useEffect(() => {
    setMenuOpen(false);
}, [location.pathname]);



  return (
    <div className="app-shell">
      <ScrollToTop />
      <header className="site-header">
        <div className="container nav-bar">
          <NavLink to="/" className="brand-block">
          <div className="brand-mark">
    <img
        src={logo}
        alt="WRC Deliverance Church Logo"
        className="brand-logo"
    />
</div>
            <div>
              <p className="brand-name">Word Revelation Church</p>
              <p className="brand-tag">Be reformed then transformed</p>
            </div>
          </NavLink>
         <div className="navigation-wrapper">

    <button
    className="menu-toggle"
    onClick={() => setMenuOpen(!menuOpen)}
>
    {menuOpen ? <FaTimes /> : <FaBars />}
</button>

   <nav
    className={`top-nav ${menuOpen ? "mobile-open" : ""}`}
>
        {navItems.map((item) => (

            <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                    isActive ? "is-active" : ""
                }
            >
                {item.label}
            </NavLink>

        ))}
    </nav>

</div>
        </div>
      </header>

      <main className="page-main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/ministries" element={<MinistriesPage />} />
          <Route path="/sermons" element={<SermonsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        <Route path="/construction" element={<ConstructionPage />} />
        <Route path="/signin" element={<Signin/>} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>

    <footer className="site-footer">

    <div className="footer-glow"></div>

    <div className="container">

        <div className="footer-top">

            <div className="footer-brand">

                <div className="footer-logo">

                    WRC

                </div>

                <h2>

                    WRC Deliverance Church

                </h2>

                <p>

                    Kona Ya Musa

                </p>

                <span>

                    A place of reformation and transformation to purposefully serve God

                </span>

            </div>

            <div className="footer-column">

                <h4>Explore</h4>

                <NavLink to="/">Home</NavLink>

                <NavLink to="/about">About</NavLink>

                <NavLink to="/ministries">Ministries</NavLink>

                <NavLink to="/sermons">Sermons</NavLink>

                <NavLink to="/news">News</NavLink>

                <NavLink to="/contact">Contact</NavLink>

                <NavLink to="/construction">Construction</NavLink>
                  <NavLink to="/signin">Administrator</NavLink>

            </div>

            <div className="footer-column">

                <h4>Visit Us</h4>

                <p>Kona Ya Musa</p>

                <p>Kwale, Kenya</p>
                <p>Tell : 0113717090</p>

                <p>Sunday Worship</p>

                <strong>7:00 AM & 10:00 AM</strong>

            </div>

            <div className="footer-column">

                <h4>Connect</h4>

                <a href="https://web.facebook.com/profile.php?id=61558426385861"
target="_blank"
rel="noopener noreferrer">Facebook</a>

                <a href="https://www.youtube.com/@DeliveranceChurchKonaYaMusa"
target="_blank"
rel="noopener noreferrer">YouTube</a>

                <a href="https://www.instagram.com/wordrevelationchurch/"
target="_blank"
rel="noopener noreferrer">Instagram</a>

                <a    href="https://wa.me/254113717090?text=Hello%20Word%20Revelation%20Church.%20I%20would%20like%20to%20know%20more%20about%20your%20church."
    target="_blank"
    rel="noopener noreferrer">WhatsApp</a>

            </div>

        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">

            <p>

                © 2026 WRC Deliverance Church Kona Ya Musa.
                All Rights Reserved.

            </p>

            <p>

                Built with KWANG'A TECHNOLOGIES•TELL(+254798104979) 

            </p>

        </div>

    </div>

</footer>
    </div>
  );
}

export default App;




